<template>
  <public-layout class="page-contact">
    <section class="section is-left-aligned contact-section">
      <div class="container">

        <div class="columns">
          <div class="column is-8">
            <iframe allowtransparency="true" :src="'//form.jotform.com/form/'+$route.params.jotform" frameborder="0" :style="('width:100%;height:' + formHeight + ';border:none;')" scrolling="no">
            <img src="/static/img/loading.gif">
            </iframe>
          </div>
        </div>

      </div>
    </section>
  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'

import Button from '@/components/Button'

import UserService from '@/services/UserService'

const Patterns = {
  EMAIL: /.+@.+\..+/i
}

export default {
  components: {
    PublicLayout,
    Button
  },
  methods: {
    changeFrameHeight () {
      this.formHeight = ((window.innerHeight < 500) ? 500 : window.innerHeight) + 'px'
    },
    onSendMessage () {
      if (this.email.length === 0) {
        this.errorMessage = 'Please enter your email'
        return false
      }
      if (Patterns.EMAIL.exec(this.email) === null) {
        this.errorMessage = 'Please enter a valid email'
        return false
      }

      const data = {
        name: this.name,
        email: this.email,
        body: this.message
      }

      this.isLoading = true

      UserService.sendContactMessage(data)
        .then(res => {
          if (res.meta.code === 200) {
            this.successMessage = res.meta.message
          } else {
            this.errorMessage = res.meta.message
          }
          this.isLoading = false
          this.name = ''
          this.email = ''
          this.message = ''
        })
    }
  },
  created () {
    window.onresize = () => this.changeFrameHeight()
  },
  data () {
    return {
      formHeight: '763px',
      email: '',
      name: '',
      message: '',
      isLoading: false,
      errorMessage: '',
      successMessage: ''
    }
  }
}
</script>

<style lang="scss">

.page-contact {
  .contact-section {
    background: url('/static/img/assets/get-in-touch.jpg') right bottom no-repeat;
    min-height: 780px;
  }

  p{
    margin-bottom: 1.5rem;
  }

  .contact-form {
    margin: 2rem 0;

    // .label {
    //   display: none;
    // }
  }
}
@media screen and (max-width: 1024px) {
  .page-contact {
    .contact-section {
      background-size: 33%;
      min-height: 370px;
    }
  }
}
@media screen and (max-width: 767px) {
  .page-contact {
    .contact-section {
      background: none;
      min-height: auto;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/RegisterPage.vue